import useLocalization from "@/hooks/useLocalization";
import { dateStringToComponents } from "@/tools/date/conversion";
import { Chip } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { darken } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { isToday, isTomorrow, parseISO } from "date-fns";

type ReservationDayHeaderProps = {
  date: string;
  reservationsCount: number;
};

export default function ReservationDayHeader({
  date,
  reservationsCount,
}: ReservationDayHeaderProps) {
  const { t } = useLocalization();
  const parsedDate = parseISO(date);
  const label = isToday(parsedDate)
    ? t("date:today")
    : isTomorrow(parsedDate)
      ? t("date:tomorrow")
      : null;
  return (
    <Box
      sx={{
        backgroundColor: (theme) => darken(theme.palette.primary.dark, 0.12),
        color: "common.white",
        px: 2,
        py: 0.3,
        zIndex: 1,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "1.05rem" }}>
          {t("date:date", {
            interpolation: dateStringToComponents(date),
          })}
        </Typography>
        {label ? (
          <Chip
            size="small"
            sx={{ backgroundColor: "white", color: "black" }}
            label={label}
          />
        ) : null}
        <Typography>
          {t("reservation:reservationsCount", {
            interpolation: { count: reservationsCount },
          })}
        </Typography>
      </Stack>
    </Box>
  );
}
